import { useDispatch, useSelector } from 'react-redux'
import { Button, styled } from '@mui/material'

import { getAIReportLabel } from '@tabeeb/modules/appConfigState/selectors'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'

import { closeAiReportDialog, openAiReportDialog } from '../../actions'
import { getHasAIReportAccess, getIsAIReportDialogOpen } from '../../selectors'

const StyledButton = styled(Button)(({ theme }) => ({
  margin: `12px 10px 0px`,
  maxWidth: `187px`,
  backgroundColor: '#0089cf',
  minWidth: 'unset',
  overflow: 'hidden',

  '&:hover': {
    backgroundColor: 'rgb(0, 95, 144)',
  },

  '& div': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textTransform: 'uppercase',
  },
}))

const AIReportButton = () => {
  const dispatch = useDispatch()

  const disabled = !useSelector(getContentId)
  const buttonLabel = useSelector(getAIReportLabel)
  const isOpen = useSelector(getIsAIReportDialogOpen)
  const hasAIReportAccess = useSelector(getHasAIReportAccess)

  const handleClick = () => {
    if (isOpen) {
      dispatch(closeAiReportDialog())
    } else {
      dispatch(openAiReportDialog())
    }
  }

  return hasAIReportAccess ? (
    <StyledButton onClick={handleClick} variant='contained' color='primary' disabled={disabled}>
      <div>{buttonLabel}</div>
    </StyledButton>
  ) : null
}

export default AIReportButton
